// export default MoreDetails;
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import axios from 'axios';
// import './MoreDetails.css';
// import { API_BASE_URL } from '../../config';

// function MoreDetails() {
//   const { app_ID } = useParams(); // Get app_ID from URL params // Ex : http://localhost:3000/moredetails/567
//   const [applicationDetails, setApplicationDetails] = useState(null);
//   const [fileExists, setFileExists] = useState({}); // Track file existence

//    // Status mappings
//    const statusMapping = {
//     1: 'Submitted',
//     2.1: 'Shortlisted',
//     2.2: 'Rejected',
//     3.1: 'Approved',
//     3.2: 'Rejected',
//     5.1: 'Granted',
//     5.2: 'Deny',
//   };

//   // Decision mappings
//   const decisionMapping = {
//     3.1: 'Approved',
//     3.2: 'Rejected',
//   };

//   useEffect(() => {
//     const fetchDetails = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/MoreDetails.php?app_ID=${app_ID}`);
//         setApplicationDetails(response.data);
//       } catch (error) {
//         console.error('Error fetching application details:', error);
//       }
//     };
  
//     fetchDetails();
//   }, [app_ID]); // Fetch data whenever app_ID changes
//   if (!applicationDetails) {
//     return <div>Loading...</div>;
//   }

  

//   const {
//     name,
//     submittedDate,
//     Status,
//     hod_decision,
//     hod_remarks,
//     hod_date,
//     dean_decision,
//     dean_remarks,
//     dean_date,
//     reviewer1_marks,
//     reviewer1_date,
//     reviewer2_marks,
//     reviewer2_date,
//     startDate,
//     period,
//     amount,
//     budget_uploaded_at,
//     uploads_uploaded_at,
//   } = applicationDetails;

//   // Function to handle download
//   const handleDownload = async (fileType) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/MoreDetailsFileDownload.php?app_ID=${app_ID}&fileType=${fileType}`, {
//         responseType: 'blob', // To handle binary files
//       });
//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = `${app_ID}_${fileType}.pdf`;
//       document.body.appendChild(link); // Append the link to the DOM
//       link.click();
//     } catch (error) {
//       console.error('Error downloading the file:', error);
//     }
//   };
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import axios from 'axios';
import './MoreDetails.css';
import { API_BASE_URL } from '../../config';

function MoreDetails() {
  const { app_ID } = useParams(); // Get app_ID from URL params // Ex : http://localhost:3000/moredetails/567
  const [applicationDetails, setApplicationDetails] = useState(null);
  const [fileExists, setFileExists] = useState({}); // Track file existence
  const userRole = localStorage.getItem('userRole');

  // Status mappings
  const statusMapping = {
    1: 'Submitted',
    2.1: 'Shortlisted',
    2.2: 'Rejected',
    3.1: 'Approved',
    3.2: 'Rejected',
    5.1: 'Granted',
    5.2: 'Deny',
  };

  // Decision mappings
  const decisionMapping = {
    3.1: 'Approved',
    3.2: 'Rejected',
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/MoreDetails.php?app_ID=${app_ID}`);
        setApplicationDetails(response.data);
      } catch (error) {
        console.error('Error fetching application details:', error);
      }
    };

    fetchDetails();
  }, [app_ID]); // Fetch data whenever app_ID changes

  // Function to check file existence
  const checkFileExistence = async (fileType) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/CheckFileExistence.php?app_ID=${app_ID}&fileType=${fileType}`);
      setFileExists((prev) => ({ ...prev, [fileType]: response.data.exists }));
    } catch (error) {
      console.error(`Error checking file existence for ${fileType}:`, error);
      setFileExists((prev) => ({ ...prev, [fileType]: false }));
    }
  };

  // UseEffect to check files existence
  useEffect(() => {
    const fileTypes = ['proposal', 'cvPrincipalInvestigator', 'cvCoInvestigators', 'agreement', 'awardLetter', 'reviewer_one', 'reviewer_two', 'progress_midyear', 'progress_endyear', 'progress_final','projectBudget','budgetRevision', 'agreementurc'];

    const checkFiles = async () => {
      await Promise.all(fileTypes.map(checkFileExistence));
    };

    checkFiles();
  }, [app_ID]);

  if (!applicationDetails) {
    return <div>Loading...</div>;
  }

  const {
    name,
    submittedDate,
    Status,
    hod_decision,
    hod_remarks,
    hod_date,
    dean_decision,
    dean_remarks,
    dean_date,
    reviewer1_marks,
    reviewer1_date,
    reviewer2_marks,
    reviewer2_date,
    startDate,
    period,
    amount,
    budget_uploaded_at,
    uploads_uploaded_at,
  } = applicationDetails;

  // // Function to handle download
  // const handleDownload = async (fileType) => {
  //   if (!fileExists[fileType]) {
  //     alert("File does not exist for this application.");
  //     return;
  //   }

  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/MoreDetailsFileDownload.php?app_ID=${app_ID}&fileType=${fileType}`, {
  //       responseType: 'blob',
  //     });

  //     if (response.data.size === 0) {
  //       alert("File not found on the server.");
  //       return;
  //     }

  //     const blob = new Blob([response.data], { type: 'application/pdf' });
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${app_ID}_${fileType}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //   } catch (error) {
  //     console.error(`Error downloading the file: ${fileType}`, error);
  //   }
  // };
  const handleDownload = async (fileType) => {
    if (!fileExists[fileType]) {
      alert("File does not exist for this application.");
      return;
    }
  
    try {
      const response = await axios.get(`${API_BASE_URL}/MoreDetailsFileDownload.php?app_ID=${app_ID}&fileType=${fileType}`, {
        responseType: 'blob',
      });
  
      if (response.data.size === 0) {
        alert("File not found on the server.");
        return;
      }
  
      // Determine the file type from the response headers
      const contentType = response.headers['content-type'];
      let fileExtension = 'pdf'; // Default to PDF
  
      if (contentType.includes('word') || contentType.includes('msword')) {
        fileExtension = 'docx';
      }
  
      // Create a Blob for downloading
      const blob = new Blob([response.data], { type: contentType });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${app_ID}_${fileType}.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(`Error downloading the file: ${fileType}`, error);
      alert("Error downloading the file.");
    }
  };
  

  return (
    <div>
      <Navbar />
      <div className="d-flex justify-content-start align-items-start mt-5">
        <div className="form-box">
          <label className="moredetailstitle">More Details about the Application No: {app_ID}</label>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Applicant Name:</Form.Label>
              <Form.Control type="text" readOnly value={name} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicDate">
              <Form.Label>Submitted Date:</Form.Label>
              <Form.Control type="text" readOnly value={submittedDate} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicStatus">
              <Form.Label>Status:</Form.Label>
              <Form.Control type="text" readOnly value={statusMapping[Status] || 'Pending'} />
            </Form.Group>

            <Form.Group className="mb-3 d-flex align-items-center" controlId="formBasicProposal">
              <Form.Label className="me-2">Project Proposal:</Form.Label>
              <Button className="downloadbutton" onClick={() => handleDownload('proposal')} disabled={!fileExists.proposal}>
                {fileExists.proposal ? "Download" : "Not Available"}
              </Button>
            </Form.Group>

            <Form.Group className="mb-3 d-flex align-items-center" controlId="formBasicCvPI">
              <Form.Label className="me-3">CV of the Principal Investigator:</Form.Label>
              <Button className="downloadbutton" onClick={() => handleDownload('cvPrincipalInvestigator')} disabled={!fileExists.cvPrincipalInvestigator}>
                {fileExists.cvPrincipalInvestigator ? "Download" : "Not Available"}
              </Button>
            </Form.Group>

            <Form.Group className="mb-3 d-flex align-items-center" controlId="formBasicCvCoInvestigators">
              <Form.Label className="me-3">CVs of all the co-investigators:</Form.Label>
              <Button className="downloadbutton" onClick={() => handleDownload('cvCoInvestigators')} disabled={!fileExists.cvCoInvestigators}>
                {fileExists.cvCoInvestigators ? "Download" : "Not Available"}
              </Button>
            </Form.Group>

            <Form.Group className="mb-3 d-flex align-items-center" controlId="formAgreement">
              <Form.Label className="me-3">Agreement ( Sign Copy Uploaded by Applicant):</Form.Label>
              <Button className="downloadbutton" onClick={() => handleDownload('agreement')} disabled={!fileExists.agreement}>
                {fileExists.agreement ? "Download" : "Not Available"}
              </Button>
            </Form.Group>


            <Form.Group className="mb-3 d-flex align-items-center" controlId="formBasicAgreementUrc">
              <Form.Label className="me-3">Agreement ( Uploaded by URC):</Form.Label>
              <Button className="downloadbutton" onClick={() => handleDownload('agreementurc')} disabled={!fileExists.agreementurc}>
                {fileExists.agreementurc ? "Download" : "Not Available"}
              </Button>
            </Form.Group>


            <Form.Label>HOD / Dean Decisions:</Form.Label>
            <Table striped bordered hover className="mt-4">
              <thead>
                <tr>
                  <th></th>
                  <th>HOD</th>
                  <th>Dean</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Decision</td>
                  <td>
                    <Form.Control type="text" readOnly value={decisionMapping[hod_decision] || 'Pending'}  />
                  </td>
                  <td>
                    <Form.Control type="text" readOnly value={decisionMapping[dean_decision] || 'Pending'}  />
                  </td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td>
                    <Form.Control type="text" readOnly value={hod_remarks} />
                  </td>
                  <td>
                    <Form.Control type="text" readOnly value={dean_remarks} />
                  </td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td>
                    <Form.Control type="text" readOnly value={hod_date} />
                  </td>
                  <td>
                    <Form.Control type="text" readOnly value={dean_date} />
                  </td>
                </tr>
              </tbody>
            </Table>

            <Form.Label>Reviewer Decisions:</Form.Label>
            <Table striped bordered hover className="mt-4">
              <thead>
                <tr>
                  <th></th>
                  <th>Reviewer One</th>
                  <th>Reviewer Two</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Marks</td>
                  <td>
                    <Form.Control type="text" readOnly value={reviewer1_marks} />
                  </td>
                  <td>
                    <Form.Control type="text" readOnly value={reviewer2_marks} />
                  </td>
                </tr>
                <tr>
  <td>Evaluation Report</td>
  <td>
    {userRole !== 'Applicant' ? (
      <Button 
        className="downloadbutton" 
        onClick={() => handleDownload('reviewer_one')} 
        disabled={!fileExists.reviewer_one}
      >
        {fileExists.reviewer_one ? "Download" : "Not Available"}
      </Button>
    ) : (
      <span className="text-muted">Not Accessible</span>
    )}
  </td>
  <td>
    {userRole !== 'Applicant' ? (
      <Button 
        className="downloadbutton" 
        onClick={() => handleDownload('reviewer_two')} 
        disabled={!fileExists.reviewer_two}
      >
        {fileExists.reviewer_two ? "Download" : "Not Available"}
      </Button>
    ) : (
      <span className="text-muted">Not Accessible</span>
    )}
  </td>
</tr>
                <tr>
                  <td>Date</td>
          
                  <td>
                    <Form.Control type="text" readOnly value={reviewer1_date} />
                  </td>
                  <td>
                    <Form.Control type="text" readOnly value={reviewer2_date} />
                  </td>
                </tr>
              </tbody>
            </Table>

            <Form.Group className="mb-3" controlId="formBasicStartDate">
              <Form.Label>Project Starting Date:</Form.Label>
              <Form.Control type="text" readOnly value={startDate} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicProjectDuration">
              <Form.Label>Project Duration:</Form.Label>
              <Form.Control type="text" readOnly value={period} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicApprovedAmount">
              <Form.Label>Approved Amount (LKR) :</Form.Label>
              <Form.Control type="text" readOnly value={amount} />
            </Form.Group>
          </Form>

          <Form.Label>Progress Reports:</Form.Label>
          {/* Reviewer Decisions Table */}
          <Table striped bordered hover className="mt-4">
            <thead>
              <tr>
                <th>Progress Report</th>
              
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mid Year</td>
                <td>
                <td>
                
                <Button className="downloadbutton" onClick={() => handleDownload('progress_midyear')} disabled={!fileExists.progress_midyear}>
                {fileExists.progress_midyear ? "Download" : "Not Available"}
                </Button>
                </td>
                </td>
               
              </tr>
              <tr>
         
      <td>Year-End</td>
      <td>
        {/* <Button 
          className="dowloadbutton"
          onClick={() => window.location.href = `/DownloadFile.php?type=progress_endyear&app_ID=${app_ID}`}>
          Download
        </Button> */}
        <Button className="downloadbutton" onClick={() => handleDownload('progress_endyear')} disabled={!fileExists.progress_endyear}>
          {fileExists.progress_endyear ? "Download" : "Not Available"}
        </Button>
      </td>
    </tr>
    <tr>
      <td>Final</td>
      <td>
        {/* <Button 
          className="dowloadbutton"
          onClick={() => window.location.href = `/DownloadFile.php?type=progress_final&app_ID=${app_ID}`}>
          Download
        </Button> */}
         
         <Button className="downloadbutton" onClick={() => handleDownload('progress_final')} disabled={!fileExists.progress_final}>
            {fileExists.progress_final ? "Download" : "Not Available"}
         </Button>
      </td>
              
               
              </tr>
            </tbody>
          </Table>

          <Form.Label>Budget:</Form.Label>
{/* Reviewer Decisions Table */}
<Table striped bordered hover className="mt-4">
  <thead>
    <tr>
      <th>Budget</th>
      <th>Date</th>
      <th>View</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
      Submitted Budget (1st Submission along with the Application) 
      </td>
     <td>
     <Form.Control type="text" readOnly value={ uploads_uploaded_at} />
    </td>
      <td>
      <Button className="downloadbutton" onClick={() => handleDownload('projectBudget')} disabled={!fileExists.projectBudget}>
        {fileExists.projectBudget ? "Download" : "Not Available"}
      </Button>
      </td>
    </tr>
    <tr>
    <td>
      Uploaded Budget (After grant Approved for Funding)
    </td>
      <td>
      <Form.Control type="text" readOnly value={ budget_uploaded_at} />
      </td>
      <td>
      
      <Button className="downloadbutton" onClick={() => handleDownload('budgetRevision')} disabled={!fileExists.budgetRevision}>
        {fileExists.budgetRevision ? "Download" : "Not Available"}
      </Button>
      </td>
    </tr>
   
  </tbody>
</Table>

        </div>
      </div>
    </div>
  );
}

export default MoreDetails;
